
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Button from 'react-bootstrap/Button';
import { useState, useEffect } from 'react';

import { TextConfig } from '../GlobalConfig';

function StNavbar() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <div>
            <nav className={`navbar navbar-expand-lg navbar-light navbar-stick-dark ts-navbar ${scrolled ? 'scrolled' : ''}`} data-navbar="sticky">
                <div className="container">

                    <div className="navbar-left">
                        <button className="navbar-toggler" type="button" onClick={toggleMenu}>
                            {menuOpen ? '✕' : '☰'}
                        </button>
                        <a className="navbar-brand text-white" href="/">
                            <img className="logo-light" src="/turbo-navbar-logo.png" alt="logo" />
                            <img className="logo-dark" src="/turbo-navbar-logo-reverse-colors.png" alt="logo" />
                        </a>
                    </div>

                    <section className={`navbar-mobile ${menuOpen ? 'show' : ''}`}>
                        <nav className="nav nav-navbar">
                            <a className="nav-link" href="/" onClick={closeMenu}>Home</a>
                            <NavDropdown title="Features" className="dropdown open-on-hover" id="features-dropdown">
                                <NavDropdown.Item className="nav-link" href="/features/ai-site-creation" onClick={closeMenu}>AI-Driven Site Creation</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/cms" onClick={closeMenu}>CMS</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/contact-forms" onClick={closeMenu}>Contact Forms</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/analytics" onClick={closeMenu}>Analytics</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/custom-domains" onClick={closeMenu}>Custom Domains</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item className="nav-link" href="/features/zip-upload" onClick={closeMenu}>Zip Upload</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/api-access" onClick={closeMenu}>API Access</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/webhooks" onClick={closeMenu}>Webhooks</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/features/cicd" onClick={closeMenu}>CI/CD</NavDropdown.Item>
                            </NavDropdown>
                            <NavDropdown title="Resources" className="dropdown open-on-hover" id="resources-dropdown">
                                <NavDropdown.Item className="nav-link" href="/docs" onClick={closeMenu}>Documentation</NavDropdown.Item>
                                <NavDropdown.Item className="nav-link" href="/blogs" onClick={closeMenu}>Blog</NavDropdown.Item>
                            </NavDropdown>
                            <a className="nav-link" href="/contactus" onClick={closeMenu}>Contact</a>
                        </nav>
                    </section>

                    <a className="btn btn-sm ts-navbar-cta" href="https://dashboard.turbosteed.com">Login</a>
                </div>

            </nav>

        </div>


    );

	{/*
    return (
    
        <div classNameName=''>
            <Navbar expand="lg" classNameName="">
                <Container fluid classNameName="">
                    <Navbar.Brand href="/#home">{TextConfig.brandName}</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav classNameName="me-auto">
                            <Nav.Link classNameName="navlink-texts" href="/#home">Home</Nav.Link>
                            <Nav.Link classNameName="navlink-texts" href="/#features">Features</Nav.Link>
                            <Nav.Link classNameName="navlink-texts" href="/#pricing">Pricing</Nav.Link>
                            <Nav.Link classNameName="navlink-texts" href="/blogs">Blogs</Nav.Link>
                            <Nav.Link classNameName="navlink-texts" href="/contactus">Contact Us</Nav.Link>
                        </Nav>
                        <Nav classNameName="ml-auto ">
                            <Button classNameName="primary" href="https://dashboard.turbosteed.com">Login</Button>
                        </Nav>

                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    
    )
    */}
}

export default StNavbar;
